// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import _ from 'underscore';

myw.svgRenderer = {
    xmlns: 'http://www.w3.org/2000/svg',

    // Symbol definitions (100 x 100, anchor at 50,50)
    symbols: {
        circle: [],
        triangle: [[50, 100], [0, 0], [100, 0], [50, 100]],
        square: [[0, 0], [100, 0], [100, 100], [0, 100], [0, 0]],
        rectangle: [[0, 25], [100, 25], [100, 75], [0, 75], [0, 25]],
        cross: [
            [0, 30],
            [0, 70],
            [30, 70],
            [30, 100],
            [70, 100],
            [70, 70],
            [100, 70],
            [100, 30],
            [70, 30],
            [70, 0],
            [30, 0],
            [30, 30],
            [0, 30]
        ],
        x: [
            [0, 20],
            [30, 50],
            [0, 80],
            [0, 100],
            [20, 100],
            [50, 70],
            [80, 100],
            [100, 100],
            [100, 80],
            [70, 50],
            [100, 20],
            [100, 0],
            [80, 0],
            [50, 30],
            [20, 0],
            [0, 0],
            [0, 20]
        ],
        building: [[50, 100], [0, 70], [0, 0], [100, 0], [100, 70], [50, 100]],
        diamond: [[50, 0], [100, 50], [50, 100], [0, 50], [50, 0]],
        chevron: [[50, 100], [0, 0], [50, 30], [100, 0], [50, 100]]
    },

    rotate(symbol, angle) {
        const rotatedPoints = _.map(this.symbols[symbol], pt =>
            this._rotatePoints(pt[0], pt[1], angle)
        );
        return rotatedPoints;
    },

    _rotatePoints(x, y, angle) {
        const cx = 50,
            cy = 50; //symbols are fixed 100x100
        const radians = (Math.PI / 180) * angle,
            cos = Math.cos(radians),
            sin = Math.sin(radians),
            nx = cos * (x - cx) + sin * (y - cy) + cx,
            ny = cos * (y - cy) - sin * (x - cx) + cy;
        return [nx, ny];
    },

    getAll() {
        const res = {};
        Object.keys(this.symbols).forEach(symbol => {
            res[symbol] = this.renderSymbol(symbol);
        });
        return res;
    },

    render(symbol) {
        const symbolPath = this.symbols[symbol];
        if (!symbolPath) throw 'symbol ' + symbol + ' is not defined';
        const svg = symbol === 'circle' ? this._createCircle() : this._createPath(symbolPath);
        svg.setAttributeNS(null, 'viewBox', '0 0 100 100');
        return svg;
    },

    _createPath(symbolPath) {
        const svg = document.createElementNS(this.xmlns, 'svg');
        const path = document.createElementNS(this.xmlns, 'path');
        const pathString = this._convertPointsToPath(symbolPath);
        path.setAttributeNS(null, 'd', pathString);
        svg.appendChild(path);
        return svg;
    },

    _createCircle() {
        const svg = document.createElementNS(this.xmlns, 'svg');
        const circle = document.createElementNS(this.xmlns, 'circle');
        circle.setAttributeNS(null, 'cx', 50);
        circle.setAttributeNS(null, 'cy', 50);
        circle.setAttributeNS(null, 'r', 45);
        svg.appendChild(circle);
        return svg;
    },

    _convertPointsToPath(coords) {
        let path = 'M';
        for (let i = 0; i < coords.length; i++) {
            path += ' ' + coords[i].join(' ');
        }
        return path;
    }
};

export default myw.svgRenderer;
